import { render, staticRenderFns } from "./LabelPreview.vue?vue&type=template&id=2b077a54&scoped=true&"
import script from "./LabelPreview.vue?vue&type=script&lang=js&"
export * from "./LabelPreview.vue?vue&type=script&lang=js&"
import style0 from "./LabelPreview.vue?vue&type=style&index=0&id=2b077a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b077a54",
  null
  
)

export default component.exports